import { render, staticRenderFns } from "./picWithdrawal.vue?vue&type=template&id=0ece1547&scoped=true"
import script from "./picWithdrawal.vue?vue&type=script&lang=js"
export * from "./picWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./picWithdrawal.vue?vue&type=style&index=0&id=0ece1547&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ece1547",
  null
  
)

export default component.exports